import { NonEmptyList, fromArrayMaybe } from 'nonempty-list';
import { MultiValue, SingleValue } from 'react-select';
import { valueFor } from '../../ListFilter';
import { SearchParameter, SearchParameters } from '../../ListFilter/Types';
import { normalizeValue } from '../../NormalizeValue';
import { StringOption } from '../Options/Types';

const getOptionToPopulateValue =
  (searchParameters: SearchParameters, key: string) =>
  (nonEmptyOptions: NonEmptyList<StringOption>): StringOption =>
    fromArrayMaybe(nonEmptyOptions.filter((o) => o.value === valueFor(key, searchParameters)))
      .map((truncatedList) => truncatedList.first)
      .getOrElseValue(nonEmptyOptions.first);

export const fetchValue = (
  searchParameters: SearchParameters,
  options: StringOption[],
  key: string,
): StringOption =>
  fromArrayMaybe(options)
    .map(getOptionToPopulateValue(searchParameters, key))
    .getOrElseValue({ value: '', label: '' });

export const handleChange =
  (updatingParameter: (searchParameters: SearchParameter) => void, key: string) =>
  (newValue: SingleValue<StringOption> | MultiValue<StringOption> | null) => {
    const option: StringOption = normalizeValue(newValue).getOrElseValue({ value: '', label: '' });

    updatingParameter({ key, value: option.value });
  };
